module.exports = __webpack_public_path__ + "static/media/desktopScreenshot04.15d0e681.jpg";